import { routerNavigatedAction } from '@ngrx/router-store';
import { on } from '@ngrx/store';

import { LoadingState } from 'src/app/utilities/state.util';

import { NewOpportunitySearchCustomersDialogActions } from './new-opportunity-search-customers-dialog.actions';
import {
  NewOpportunitySearchCustomersDialogState,
  newOpportunitySearchCustomersDialogInitialState,
} from './new-opportunity-search-customers-dialog.state';

export const newOpportunitySearchCustomersDialogReducers = [
  on(
    NewOpportunitySearchCustomersDialogActions.searchCustomersDialogOpened,
    (_state: NewOpportunitySearchCustomersDialogState, { query }): NewOpportunitySearchCustomersDialogState => ({
      ...newOpportunitySearchCustomersDialogInitialState,
      show: true,
      query: query ?? '',
    }),
  ),
  on(
    NewOpportunitySearchCustomersDialogActions.searchQueryChanged,
    (state: NewOpportunitySearchCustomersDialogState, { query }): NewOpportunitySearchCustomersDialogState => {
      const sanitizedQuery = query ?? '';
      const trimmedQuery = sanitizedQuery.trim();

      if (trimmedQuery.length > 0) {
        return {
          ...state,
          query: sanitizedQuery,
        };
      }

      return {
        ...state,
        query: '',
        customers: [],
        callState: LoadingState.INIT,
      };
    },
  ),
  on(
    NewOpportunitySearchCustomersDialogActions.searchCustomersStarted,
    (state: NewOpportunitySearchCustomersDialogState): NewOpportunitySearchCustomersDialogState => ({
      ...state,
      customers: [],
      callState: LoadingState.LOADING,
    }),
  ),
  on(
    NewOpportunitySearchCustomersDialogActions.searchCustomersSuccess,
    (state: NewOpportunitySearchCustomersDialogState, { customers }): NewOpportunitySearchCustomersDialogState => ({
      ...state,
      customers,
      callState: LoadingState.LOADED,
    }),
  ),
  on(
    NewOpportunitySearchCustomersDialogActions.searchCustomersError,
    (state: NewOpportunitySearchCustomersDialogState, { error }): NewOpportunitySearchCustomersDialogState => ({
      ...state,
      customers: [],
      callState: { error },
    }),
  ),
  on(
    NewOpportunitySearchCustomersDialogActions.searchCustomersDialogClosed,
    NewOpportunitySearchCustomersDialogActions.customerRowClicked,
    (): NewOpportunitySearchCustomersDialogState => ({
      ...newOpportunitySearchCustomersDialogInitialState,
    }),
  ),
  on(
    routerNavigatedAction,
    (
      state: NewOpportunitySearchCustomersDialogState,
      { payload: { event: { urlAfterRedirects } } },
    ): NewOpportunitySearchCustomersDialogState => {
      if (urlAfterRedirects.startsWith('/jobs/new') || /^\/jobs\/[^/]+\/edit/.test(urlAfterRedirects)) {
        return state;
      }

      return newOpportunitySearchCustomersDialogInitialState;
    },
  ),
] as const;
